import React, { useEffect, useRef, useState } from 'react';
import '../../../assets/css/subscription.css';
import CheckBroken from '../../../assets/img/check-circle-broken.svg';
import { Link, useNavigate } from 'react-router-dom';
import Header from 'components/Header';

const SubCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="wrapper">
        <Header />
      <div className="main-content">
        <section className="subscription-sec">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-12">
                <div className="blankList-box-cover">
                  <div className="blankList-box">
                    <img className="akarFile" src={CheckBroken} />
                    <h2>Thank You—We’ll Miss You 💔 </h2>
                    <p>Your subscription has been cancelled, but we truly appreciate the time you spent with us.</p>

                    <Link to="/projects" className="btn-black">
                      Go to Dashboard
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default SubCancel;
